import { useState, Dispatch, SetStateAction } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { NOTE_FIELDS } from '../../common/noteSchema';

export type SuggestionProps = {
  hasSuggestionStartTime: boolean;
  hasSuggestionEndTime: boolean;
  hasSuggestionDuration: boolean;
  setHasSuggestionStartTime: Dispatch<SetStateAction<boolean>>;
  setHasSuggestionEndTime: Dispatch<SetStateAction<boolean>>;
  setHasSuggestionDuration: Dispatch<SetStateAction<boolean>>;
};
export const useSuggestionProps = (): SuggestionProps => {
  const { control } = useFormContext();
  const startTime = useWatch({ name: NOTE_FIELDS.START_TIME, control });
  const endTime = useWatch({ name: NOTE_FIELDS.END_TIME, control });
  const duration = useWatch({ name: NOTE_FIELDS.DURATION, control });

  const [hasSuggestionStartTime, setHasSuggestionStartTime] = useState(
    startTime !== null && startTime ? false : true
  );
  const [hasSuggestionEndTime, setHasSuggestionEndTime] = useState(
    endTime !== null && endTime ? false : true
  );
  const [hasSuggestionDuration, setHasSuggestionDuration] = useState(
    duration !== 0 && duration ? false : true
  );

  return {
    hasSuggestionStartTime,
    hasSuggestionEndTime,
    hasSuggestionDuration,
    setHasSuggestionStartTime,
    setHasSuggestionEndTime,
    setHasSuggestionDuration
  };
};
